var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.kind === 'yn')?_c('span',{staticClass:"yn",class:_vm.value},[_vm._v(_vm._s(_vm.label))]):_c('span',{staticClass:"status",class:'st-' + _vm.tone},[_c('span',{staticClass:"dot"}),_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }